import useCars from 'app/hook/cars/useCars';

export default function useOption() {
	const { base, optionStandard, optionStandardTruck, optionChoice, optionTuning } = useCars();
	// 차량옵션 활성화 정보
	const baseStandard = base.options?.standard;
	// 기본옵션에 isCarActive 설정
	const standardText = base.vehicleType === 'CAR' ? optionStandard : optionStandardTruck;
	const optionData = standardText.options?.map((item) => {
		let subCheck = false;
		const subItems = item.subOptions?.map((sub) => {
			const result = baseStandard.indexOf(sub.optionCd) > -1;
			const subs = {
				...sub,
				isCarActive: result,
			};
			if (result) subCheck = true;
			return subs;
		});
		const items = {
			...item,
			isCarActive: item.subOptions ? subCheck : baseStandard.indexOf(item.optionCd) > -1,
			subOptions: subItems,
		};
		return items;
	});
	const optionActiveTotal = baseStandard ? baseStandard.length : '-';
	const optionUse = (value) => baseStandard.indexOf(value) > -1;

	// 선택 옵션
	const baseChoice = base.options?.choice || [];
	const choiceData = optionChoice.length ? optionChoice.filter((item) => baseChoice.find((e) => e === item.optionCd)) : [];
	const choiceDataTotalPrice = choiceData.reduce((acc, cur) => acc + cur.price, 0);

	// 튜닝 옵션
	const baseTuning = base.options?.tuning || [];
	const tuningData = optionTuning.length ? baseTuning.map((item) => optionTuning.find((e) => e.optionCd === item)) : [];
	return {
		baseStandard,
		baseChoice,
		baseTuning,
		optionData,
		optionActiveTotal,
		optionUse,
		choiceData,
		choiceDataTotalPrice,
		tuningData,
		optionStandard,
		optionStandardTruck,
		standardText,
	};
}
